<template>
    <modal @close="editMobileNumberCancelClick" hideFooter id="edit-mobile-number" style="max-width: 800px;">
        <div class="td-container">
            <h3>Edit Mobile Number</h3>

            <div v-if="isAdmin">
                <p>Enter a new mobile number for this user.</p>
                <p>
                    The changes will be applied immediately, no verification is required.
                </p>
            </div>
            <div v-else>
                <p>A verification text will be sent to the new mobile number before changes are applied.</p>
            </div>

            <label class="td-label td-text-bold mt-0">New Mobile Number:</label>
            <div class="td-banner danger slim my-1" v-if="errorMessage.length > 0">
                <icon class="icon" type="solid" name="faTriangleExclamation" aria-hidden="true"></icon>
                <div> {{ errorMessage }}</div>
            </div>

            <div v-if="isAdmin">
                <p>
                    <input type="text" v-model="newMobile" />
                </p>
                <p v-if="v$.newMobile.$error" class="td-error">Please enter a valid mobile number.</p>
                <p>
                    <button class="td-btn primary" @click="updateMobileSkip">Save</button>
                </p>

            </div>
            <div v-else>
                <AddressValidator @validated="updateMobile" @skip="updateMobileSkip"
                                  :reset="usernameResetTrigger"
                                  :disable-email="true"
                                  :disable-validation="false"
                                  :disable-password="true"
                                  :validation-failed="false"
                                  :enable-username="false" v-model="newMobile"
                                  :with-password="false"
                                  :update-existing="true"
                                  :allow-skip="newMobile == ''"
                                  placeholder="Enter mobile number">
                </AddressValidator>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditMobileNumber';
    export default script;
</script>
<style lang="less">
    @import './EditMobileNumber.less';
</style>